import D2C_ServiceOther from './Other'

class D2C_ServiceSkyDNS extends D2C_ServiceOther {
  static objectType = 'serviceType'
  static active = false
  static typeName = 'skydns'
  static typeTitle = 'SkyDNS'
  static color = '#33aacc'
  static fields = {
    ...D2C_ServiceOther.fields,
    hosts: {
      ...D2C_ServiceOther.fields.hosts,
      selector: {
        default: ['node'],
      },
    },
    image: {
      ...D2C_ServiceOther.fields.image,
      default: 'skydns',
    },
    ports: {
      ...D2C_ServiceOther.fields.ports,
      default: [
        {protocol: 'UDP', value: 53},
      ],
    },
    version: {
      ...D2C_ServiceOther.fields.version,
      default: 'latest',
      enum: ['latest'],
    },
  }
}

export default D2C_ServiceSkyDNS
